import { useProjectContext } from "components/pages/FeaturedProjects/contexts/Project";
import { useVote } from "hooks/useVote";
import VoteCard from "./VoteCard";
import classes from "./classes.module.scss";

export default function Votes() {
	const { project } = useProjectContext();
	const { generalVotes, fetchGeneralVotes, userHasVoted } = useVote(project);

	return (
		<div className={classes["root"]}>
			{generalVotes.map((voteWithResults) => (
				<div key={voteWithResults.question.id} className={classes["vote-card-container"]}>
					<VoteCard showResults={userHasVoted(voteWithResults.question)} voteWithResults={voteWithResults} onVote={fetchGeneralVotes} />
				</div>
			))}
		</div>
	);
}
